import React, { useEffect, useState } from 'react';
import { Form, FormFeedback, Input } from 'reactstrap';
import Switch from "react-switch";
import { Offsymbol, OnSymbol } from '../../../constants/holcim';
import { BaseCustomModal, GradientDecorationLine, BaseCustomButton } from '../../../shared';
import { useFormik } from "formik";
import * as Yup from "yup";

export const CustomerRegisterModal = ({ setShowModal, showModal, modalRespInfo, isUpdate, rowInfo, modalClose }) => {
    const [active, setActive] = useState(true);
    const [lockActive, setLockActive] = useState(true);

    useEffect(() => {
        setActive(isUpdate ? rowInfo.recordStatus : true);
        setLockActive(!isUpdate);
    }, [showModal]);

    const formikFormData = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: isUpdate ? rowInfo.name : '',
            customerType: isUpdate ? rowInfo.customerType : '',
            phone: isUpdate ? rowInfo.phone : '',
            email: isUpdate ? rowInfo.email : '',
            address: isUpdate ? rowInfo.address : '',
        },
        validationSchema: Yup.object({
            name: Yup.string().required("Ingrese el nombre"),
            email: Yup.string().email('Correo inválido').required('Ingrese el correo'),
            phone: Yup.string().matches(/^[0-9]+$/, 'Número inválido'),
            address: Yup.string().required("Ingrese dirección"),
            customerType: Yup.string().required("Seleccione un tipo"),
        }),
        onSubmit: (values) => {
            modalRespInfo(values, active);
            formikFormData.resetForm();
            setShowModal(false);
        }
    });

    const onClosed = () => {
        formikFormData.resetForm();
        modalClose();
        setShowModal(false);
    };

    const children_form = (
        <div>
            <h4 className='text-primary m-0 ps-4'>Registro/Actualización de Clientes</h4>

            <GradientDecorationLine />

            <Form
                className="form-horizontal mt-3 mb-1"
                onSubmit={(e) => {
                    e.preventDefault();
                    formikFormData.handleSubmit();
                    return false;
                }}
            >
                <div className="mb-3 px-5">
                    <label className='text-primary'>Nombre de Cliente</label>
                    <Input
                        name="name"
                        className="form-control text-primary"
                        placeholder="Nombre Cliente"
                        type="text"
                        onChange={formikFormData.handleChange}
                        onBlur={formikFormData.handleBlur}
                        value={formikFormData.values.name || ""}
                        invalid={
                            formikFormData.touched.name && formikFormData.errors.name ? true : false
                        }
                    />
                    {formikFormData.touched.name && formikFormData.errors.name ? (
                        <FormFeedback type="invalid">{formikFormData.errors.name}</FormFeedback>
                    ) : null}
                </div>
                <div className="mb-1 px-5">
                    <label className='text-primary'>Tipo de Cliente</label>
                    <select
                        required
                        defaultValue=""
                        name="customerType"
                        className="form-select text-primary"
                        placeholder="Tipo de Cliente"
                        onChange={formikFormData.handleChange}
                        onBlur={formikFormData.handleBlur}
                        value={formikFormData.values.customerType || ""}
                    >
                        <option value="">Seleccione Tipo de Cliente</option>
                        <option value="Interno">Interno</option>
                        <option value="Externo">Externo</option>
                    </select>
                </div>
                <div className="mb-3 px-5">
                    <label className='text-primary'>Teléfono</label>
                    <Input
                        name="phone"
                        className="form-control text-primary"
                        placeholder="Teléfono"
                        type="text"
                        onChange={formikFormData.handleChange}
                        onBlur={formikFormData.handleBlur}
                        value={formikFormData.values.phone || ""}
                        invalid={
                            formikFormData.touched.phone && formikFormData.errors.phone ? true : false
                        }
                    />
                    {formikFormData.touched.phone && formikFormData.errors.phone ? (
                        <FormFeedback type="invalid">{formikFormData.errors.phone}</FormFeedback>
                    ) : null}
                </div>
                <div className="mb-3 px-5">
                    <label className='text-primary'>Correo Electrónico</label>
                    <Input
                        name="email"
                        className="form-control text-primary"
                        placeholder="Correo Electrónico"
                        type="text"
                        onChange={formikFormData.handleChange}
                        onBlur={formikFormData.handleBlur}
                        value={formikFormData.values.email || ""}
                        invalid={
                            formikFormData.touched.email && formikFormData.errors.email ? true : false
                        }
                    />
                    {formikFormData.touched.email && formikFormData.errors.email ? (
                        <FormFeedback type="invalid">{formikFormData.errors.email}</FormFeedback>
                    ) : null}
                </div>
                <div className="mb-3 px-5">
                    <label className='text-primary'>Domicilio</label>
                    <Input
                        name="address"
                        className="form-control text-primary"
                        placeholder="Domicilio"
                        type="text"
                        onChange={formikFormData.handleChange}
                        onBlur={formikFormData.handleBlur}
                        value={formikFormData.values.address || ""}
                        invalid={
                            formikFormData.touched.address && formikFormData.errors.address ? true : false
                        }
                    />
                    {formikFormData.touched.address && formikFormData.errors.address ? (
                        <FormFeedback type="invalid">{formikFormData.errors.address}</FormFeedback>
                    ) : null}
                </div>

                <div className="px-5">
                    <div className='text-primary pb-2'>Activo</div>
                    <Switch
                        disabled={lockActive}
                        className='me-4'
                        uncheckedIcon={<Offsymbol />}
                        checkedIcon={<OnSymbol />}
                        onColor="#94C12E"
                        onChange={() => { setActive(!active) }}
                        checked={active}
                    />
                </div>

            </Form>
            <div className='mt-5'>
                <GradientDecorationLine />
                <div className="page-title-box d-flex justify-content-end">
                    <BaseCustomButton
                        outline
                        color="primary"
                        className='rounded-3 me-3'
                        onClick={formikFormData.handleSubmit}
                        icon='mdi mdi-content-save me-1'
                        label='Guardar'
                    />
                    <BaseCustomButton
                        outline
                        color="danger"
                        className='rounded-3'
                        onClick={onClosed}
                        icon='mdi mdi-close-circle-outline me-1'
                        label='Cancelar'
                    />
                </div>
            </div>
        </div>
    );

    return (
        <BaseCustomModal
            isModalOpen={showModal}
            handleCancel={onClosed}
            handleOk={onClosed}
            footer={null}
            children={children_form}
            width={700}
        />
    );
};